export interface AppPage {
  id: string;
  module: string;
  path: string;
  hidden: boolean;
}
